<template>
	<div v-if="show" class="sort-wrapper" @click="close">
		<div class="sort-container" @click.stop.prevent="() => false">
			<h3 class="sort-title">ALTERAR SEQUÊNCIA</h3>

			<button class="sort-close" @click="close">
				<i class="fa fa-fw fa-times"></i>
			</button>

			<div v-if="!loaded" class="sort-form">
				<div class="row">
					<div class="col-xs">
						<FormSelect :options="my_drivers_reduced" v-model="filter_driver" label="Motorista" icon="fa-id-card" :multiple="false" tooltip="Selecione o motorista" :required="false" />
					</div>
				</div>
				<div class="row">
					<div class="col-xs">
						<FormInput v-model="filter_license_plate" label="Placa do veículo" icon="fa-truck" tooltip="Informe a placa do veículo" @keydown.enter.prevent="search" />
					</div>
				</div>
				<div class="row">
					<div class="col-xs">
						<FormInput v-model="filter_cargo" label="Carga (opcional)" icon="fa-box-open" tooltip="Selecione a carga" @keydown.enter.prevent="search" />
					</div>
				</div>
				<button class="sort-submit" @click="search" :disabled="loading">
					<i v-if="loading" class="fa fa-fw fa-circle-notch fa-spin"></i> 
					<i v-if="!loading" class="fa fa-fw fa-search"></i> 
					BUSCAR ENTREGAS
				</button>
			</div>

			<div v-if="loaded" class="row">
				<div class="col-xs">
					<span class="sort-info-span"><b>Motorista:</b> {{ filter_driver }}</span><br/>
					<span class="sort-info-span"><b>Placa:</b> {{ filter_license_plate }}</span>
				</div>
			</div>

			<div v-if="loaded" class="table-wrapper">
				<table class="list-group">
					<thead>
						<tr>
							<th>Nota</th>
							<th>Cliente</th>
							<th>Carga</th>
							<th>Data</th>
						</tr>
					</thead>
					<tbody class="tbody" ref="list">
						<tr class="list-group-item" v-for="(item, idx) in this.list" :key="idx" :data-id="item.id">
							<td><b>#{{ item.document_number }}</b></td>
							<td>{{ item.xml.DESTINATARIO_RAZAO_SOCIAL_OU_NOME }}</td>
							<td>{{ item.cargo }}</td>
							<td>{{ item.date.split("-").reverse().join("/") }}</td>
						</tr>
					</tbody>
				</table>
			</div>
			<button v-if="loaded" class="sort-submit" @click="save" :disabled="loading">
				<i v-if="loading" class="fa fa-fw fa-circle-notch fa-spin"></i> 
				<i v-if="!loading" class="fa fa-fw fa-save"></i> 
				SALVAR SEQUÊNCIA
			</button>
		</div>
	</div>
</template>

<script>
import Api from "@/lib/Api";
import { Sortable } from "sortablejs";

import FormInput from "@/components/FormInput";
import FormSelect from "@/components/FormSelect";

export default {
	name: "DeliverySort",

	components: { FormInput, FormSelect },

	props: [ "show", "my_drivers_reduced" ],

	data: function() {
		return {
			loading: false,

			filter_driver: '',
			filter_license_plate: '',
			filter_cargo: '',

			loaded: false,
			list: [],
			ordered_list: [],

			sortable: null,
		}
	},

	methods: {
		search: async function() {
			if (!this.filter_driver) return;
			if (!this.filter_license_plate) return;

			this.loading = true;
			let res = await Api.post("delivery/get-reorder", { 
				driver_document: this.filter_driver,
				license_plate: this.filter_license_plate,
				cargo: this.filter_cargo
			});
			this.loading = false;

			if (res.error) {
				this.$notification.error(res.data);
				this.close();
				return;
			}

			this.list = res.data;
			this.loaded = true;

			this.$nextTick(() => {
				this.sortable = new Sortable(this.$refs.list, {

				});
			});
		},

		close: function() {
			this.$parent.show_modal_sort = false
		},

		save: async function() {
			const order = this.sortable.toArray();

			let form = {
				sequence: {}
			};

			let i = 1;
			for (let nf of order) {
				form.sequence[nf] = i;
				i++;
			}

			this.loading = true;
			let res = await Api.post("delivery/set-reorder", form);
			this.loading = false;

			if (res.error) {
				this.$notification.error(res.data);
			} else {
				this.$notification.success('Alterado com sucesso.');
			}

			this.close();
		},
	}
}

</script>


<style scoped>

.sort-wrapper {
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	background: #00000044;
}

.sort-container {
	position: absolute;
	width: 500px;
	height: calc(100vh - 100px);
	margin: auto;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: #fff;
	padding: 0 15px 15px 15px; /*50px 15px 15px 15px;*/
}

.sort-container > h4 {
	text-align: center;
	padding: 30px;
}

.sort-title {
	margin-top: 15px;
}

.sort-close {
	position: absolute;
	right: 0;
	top: 0;
	background: none;
	border: none;
	width: 50px;
	height: 50px;
	text-align: center;
	line-height: 50px;
	padding: 0;
	font-size: 16px;
	color: #999;
}

.sort-submit {
	width: 100%;
	height: 40px;
	border: none;
	background: #222;
	color: #fff;
	font-weight: bold;
}


.sort-info-span {
	font-size: 14px;
}

.list-group {
	width: 100%;
	padding: 0;
	margin-top: 35px;
	border-top: 1px solid #ccc;
	text-align: left;
	border-spacing: 0;
	border-collapse: collapse;
}
.list-group th, .list-group td {
	padding: 5px;
	font-size: 12px;
	border: 1px solid #eee;
	margin: 0;
}

.list-group-item {
	padding: 0;
	border: 1px solid #ccc;
	border-top: none;
	padding: 5px;
	font-size: 14px;
}
.list-group-item:hover {
	opacity: 0.8;
}
.list-group-item, .list-group-item * {
	cursor: pointer !important;
}

.table-wrapper {
	height: calc(100% - 140px);
	overflow-y: auto;
	margin-bottom: 5px;
}
</style>